import GlobalDeleteDialog from "../../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteQrCode,
  getAllQrcodes,
} from "../../../../redux/features/qrCodesSlice";
import { useSelector } from "react-redux";

const DeleteQrCode = (id) => {
  const { loading } = useSelector((state) => state.qrCodes);
  return (
    <GlobalDeleteDialog
      title={"Delete Qr Code"}
      deleteNote={"Are you sure ? you want to delete this Qr Code..!"}
      api={deleteQrCode(id)}
      btnName={true}
      upDateCall={getAllQrcodes()}
      loading={loading}
    />
  );
};

export default DeleteQrCode;
